import { createContext, Context } from 'react';
import { AuthenticationController } from 'providers/authentication/authentication.controller';

export const AuthenticationContext: Context<AuthenticationController> = createContext<AuthenticationController>(new AuthenticationController());